/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-container/~/lodash/_stackGet.js
// module id = ./node_modules/victory-brush-container/node_modules/lodash/_stackGet.js
// module chunks = 1